/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupempty1Inputs */

const en_signupempty1 = /** @type {(inputs: Signupempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sign-ups yet.`)
};

const de_signupempty1 = /** @type {(inputs: Signupempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Anmeldungen.`)
};

/**
* | output |
* | --- |
* | "No sign-ups yet." |
*
* @param {Signupempty1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupempty1 = /** @type {((inputs?: Signupempty1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupempty1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupempty1(inputs)
	return de_signupempty1(inputs)
});
export { signupempty1 as "signupEmpty" }